<template>
    <div class="login">
        <b-container fluid>
            <b-row><b-col><br><br><br><br><br><br></b-col></b-row>
            <b-row>
                <b-col>
                    <b-alert :show="dismissCountDown" dismissible variant="warning" @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged" >
                        <p>{{ message }}</p>
                    </b-alert>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="3"></b-col>
                <b-col cols="6">
                    <b-form @submit="rld">
                        <b-form-group id="input-group-1" label="Name:" label-for="input-1">
                            <b-form-input id="input-1" v-model="name" type="text" placeholder="Enter your name" required ></b-form-input>
                        </b-form-group>
                        <b-form-group id="input-group-1" label="Surname:" label-for="input-1">
                            <b-form-input id="input-1" v-model="surname" type="text" placeholder="Enter your surname" required ></b-form-input>
                        </b-form-group>
                        <b-form-group id="input-group-1" label="Company:" label-for="input-1">
                            <b-form-input id="input-1" v-model="company" type="text" placeholder="Insert your company name" required ></b-form-input>
                        </b-form-group>
                        <b-form-group id="input-group-1" label="E-Mail Address:" label-for="input-1">
                            <b-form-input id="input-1" v-model="email" type="email" placeholder="Enter your email" required ></b-form-input>
                        </b-form-group>
                        <b-form-group id="input-group-1" label="Phone number:" label-for="input-1">
                            <b-form-input id="input-1" v-model="phone" type="tel" placeholder="Insert your phone number" required ></b-form-input>
                        </b-form-group>
                        <br><br>
                        <b-button type="submit" variant="primary">Send Your Request</b-button>
                    </b-form>
                </b-col>
                <b-col cols="3"></b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { API } from "@/api.js";

export default {
    name: "Home",
    data() {
        return {
            name: "",
            surname: "",
            company: "",
            email: "",
            phone: "",
            dismissCountDown: 0,
            dismissSecs: 5,
            message: "",
        };
    },
    components: {},
    mounted() {
        // this.$store.commit("logout");
    },
    computed: {
        logged() {
            // console.log("logged", this.$store.getters.logged);
            return this.$store.getters.logged ? "si" : "no";
        },
    },
    methods: {
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },
        async rld(event){
            event.preventDefault();
            await API.rld(this.name, this.surname, this.company, this.email, this.phone);
            this.message = "Thank you for your request. We'll be back to you with your login data as soon as possible"
            this.dismissCountDown = this.dismissSecs;
            setTimeout(this.go,this.dismissSecs*1000)
        },
        go(){
            this.$router.push("/");
        }
    },
};
</script>
<style scoped>
div.login {
    background-color: #cddecd;
    height: calc(100vh - 120px);
}
h2.t50 {
    font-weight: bold;
    position: relative;
    top: 50px;
}
form.loginform {
    display: inline-block;
    position: relative;
    top: 50px;
    width: 50%;
}
form button {
    position: absolute;
    right: 0px;
	left: 0px;
    background-color: #9a240d;
    border-color: #9a240d;
}
form.logoutform {
    height: 100px;
}
form.logoutform button {
    position: absolute;
    right: 0px;
	left: 0px;
    background-color: #9a240d;
    border-color: #9a240d;
}
</style>
<style>
form.loginform label {
    text-align: left;
}
</style>
